import React, { FC } from 'react';
import moment from 'moment/moment';

import { Txt } from '../../text';

interface DateTimeCellProps {
  value: string;
  hideDate?: boolean;
  hideTime?: boolean;
  className?: string;
}

const DateTimeCell: FC<DateTimeCellProps> = (props) => {
  const { value, hideDate, hideTime } = props;
  const format = [!hideDate ? 'DD.MM.YYYY' : '', !hideTime ? 'HH:mm' : ''];

  const date = moment(value);
  return (
    <Txt  fontSize='sm'>
      {date.isValid() ? date.format(format.join(' ')) : ''}
    </Txt>
  );
};

export default DateTimeCell;
